import styled from 'styled-components';

const Uploader = styled.div`
  width: 100%;
  height: 100%;
`;

export { Uploader };
